import { Box, Button, Container, Typography } from '@mui/material';
import Cookies from 'js-cookie';
import React, { useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { TextInput } from '../../components';
import { userApis } from '../../services/apis/global';
import { urls } from '../../services/endPoint';
import { api } from '../../services/http';
import { SET_LOADING } from '../../services/redux/reducers/loadingSlice';
import { SET_LOGGED_IN, user } from '../../services/redux/reducers/userSlice';
import { AppDispatch, useAppDispatch, useAppSelector } from '../../services/redux/store';

type LoginState = 'phoneNumber' | 'otp' | 'complete-profile';
type LoginForm = {
  phoneNumber: string;
  otp?: string;
  name?: string;
  lastName?: string;
  nationalCode?: string;
  birthday?: string;
};

export default function Login() {
  const {
    reset,
    handleSubmit,
    control,
    getValues,
    setValue
  } = useForm<LoginForm>();
  const [loginState, setLoginState] = useState<string>(sessionStorage.getItem('login-step') || 'phoneNumber');
  const userReducer = useAppSelector(state => state.userReducer);
  const formRef = useRef(null);
  const tokenRef = useRef<null | string>(null);
  const dispatch: AppDispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleSubmitForm = async (data: LoginForm = null) => {
    // Send phonenumber here ...
    const reqOptions = {
      method: 'post',
      body: data,
    };

    dispatch(SET_LOADING(true));
    const res = await api(urls.login, reqOptions);
    dispatch(SET_LOADING(false));
    tokenRef.current = res.token;
    if (res.code == 200) {
      dispatch(SET_LOGGED_IN(true));
      dispatch(user(res.data.user));
      Cookies.set('worker-token', res.data.token, {
        expires: 30 * 24 * 60 * 60,
        path: '/'
      });
      toast('خوش آمدید', { type: 'success' });
      await userApis(dispatch);
      navigate('/');
    } else {
      toast('نام کاربری یا رمز عبور اشتباه است', { type: 'error' });
    }
  };

  if (userReducer.isLoggedIn) {
    navigate('/');
  }

  return (
    <Box
      component="main"
      bgcolor="white"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh'
      }}
    >
      <Container
        sx={{
          height: '50vh',
          py: 4,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          gap: 4,
        }}
      >
        <Typography
          variant="h3"
          component="h1"
          textAlign="center"
          color="var(--mid-pink)"
          sx={{
            filter: 'drop-shadow(0px 4px 2px rgb(201, 182, 182))',
          }}
        >
          nilman
        </Typography>
        <Box sx={{
          display: 'grid',
          placeItems: 'center'
        }}>
          {/*<Box*/}
          {/*  p={2}*/}
          {/*  borderRadius={50}*/}
          {/*  sx={{backgroundColor: 'white'}}*/}
          {/*>*/}
          <Box width={180} height={180} component="img" src="./img/nilmanLogo.png"/>
          {/*</Box>*/}
        </Box>
      </Container>
      <Container
        sx={{
          flex: 1,
          bgcolor: 'var(--mid-pink)',
          borderTopRightRadius: '80px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          pt: 8,
          pb: 4,
        }}
      >
        <Box
          component="form"
          width="100%"
          onSubmit={handleSubmit(handleSubmitForm)}
          ref={formRef}
        >
          <Box display="flex" flexDirection="column" gap={4}>
            <TextInput
              label="نام کاربری"
              name="username"
              control={control}
              defaultValue=""
              size="medium"
              autoComplete="off"
              type="text"
              sx={{
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: 'var(--mid-pink)',
                  backgroundColor: 'var(--white-pink)',
                  borderRadius: '10px',
                },
                '& .MuiOutlinedInput-input': {
                  zIndex: 1,
                },
              }}
            />
            <TextInput
              label="رمز عبور"
              name="password"
              control={control}
              defaultValue=""
              size="medium"
              autoComplete="off"
              type="password"
              sx={{
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: 'var(--mid-pink)',
                  backgroundColor: 'var(--white-pink)',
                  borderRadius: '10px',
                },
                '& .MuiOutlinedInput-input': {
                  zIndex: 1,
                },
              }}
            />
            <Button
              variant="contained"
              type="submit"
              sx={{
                bgcolor: 'var(--light-pink)',
                py: 1,
                fontSize: 18,
                color: 'var(--light-black)',
                ':hover': { color: '#fff' },
              }}
              fullWidth
            >
              ثبت
            </Button>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
